
<div style="display: flex; min-height: 100vh;">

  <div style="flex: 1; padding: 2rem; background-color: #f2f2f2;">
    <div class="chat-container">
      <app-chat-history
        [messages]="history"
        class="chat-history">
      </app-chat-history>

      <div class="input-area">
        <input
          type="text"
          autofocus
          placeholder="Type a message..."
          class="message-input"
          [(ngModel)]="newMessage"
          (keyup.enter)="send()"
        />
        <button type="button" (click)="send()" [disabled]="!newMessage.trim()">Send</button>
      </div>
    </div>
  </div>

  <div style="flex: 1; padding: 2rem;">
    <div style="width: 800px; height: 600px;">
      <presentation-preview #templateEditorPreviewHolder>
      </presentation-preview>
    </div>
  </div>

</div>

